var action = 'click';
var speed = "500";
var deweysJquery = null;
const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      //console.log("heard cart update");
      /*window.SLIDECART_UPDATE(function() {
        if (typeof(calculateFSB) !== 'undefined') {
          calculateFSB();
        }
        cloneFreeShippingBar(null);
      });
      */
        if (typeof(calculateFSB) !== 'undefined') {
          calculateFSB();
        }
        cloneFreeShippingBar(null);
    
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

if (typeof Checkout !== 'undefined') {
  (function($) {
    $(document).on("page:load page:change", function() {
      //FAQ handler
      $('.order-summary__sections').on(action, 'li.checkout-q', (function(){
        //gets next element
        //opens .a of selected question
        $(this).next().slideToggle(speed)
          //selects all other answers and slides up any open answer
          .siblings('li.checkout-a').slideUp();

        //Grab img from clicked question
        var img = $(this).children('img');
        //Remove Rotate class from all images except the active
        $('img').not(img).removeClass('rotate');
        //toggle rotate class
        img.toggleClass('rotate');
      }));

      addFAQMenu($, ".order-summary__sections");

    });
        
    $("#Cart").on("mouseup", "input#sc-discount__submit", (function (event) {
        //wait for coupon code to be submitted 
        if (window.timerCodeSearch) clearInterval(window.timerCodeSearch);
        window.timerCodeSearch = setInterval(function() {
            if ($(".sc_simple-info span.code").length) {
                // recalculate shipping banner
                calculateFSB();
                clearInterval(window.timerCodeSearch);
            }
        }, 100);
    
    }));
    $("#Cart").on("keydown", "input#code.sc-cube-text.sc-cube-code", (function (event) {
        if (event.keyCode == 13) {
            //wait for coupon code to be submitted 
            if (window.timerCodeSearch) clearInterval(window.timerCodeSearch);
            window.timerCodeSearch = setInterval(function() {
                if ($(".sc_simple-info span.code").length) {
                    // recalculate shipping banner
                    calculateFSB();
                    clearInterval(window.timerCodeSearch);
                }
            }, 100);
        }
    }));
    
    
    $("#Cart").on("mousedown", "button.button", (function(){
        //remove coupon
        if (window.timerCodeSearchRemove) clearInterval(window.timerCodeSearchRemove);
        window.timerCodeSearchRemove = setInterval(function() {
            if ($(".sc_simple-info span.code").length == 0) {
                // recalculate shipping banner
                calculateFSB();
                clearInterval(window.timerCodeSearchRemove);
            }
        }, 100);
    }));
  })(Checkout.$);
}
else {
  //cart page FAQ menu
  window.onload = function() {
  	jQuery(document).ready(function($) {
      deweysJquery = $;
      
      checkDiscount($);

            //FAQ handler
      $('.cart__buttons-wrapper').on(action, 'li.checkout-q', (function(){
        //gets next element
        //opens .a of selected question
        $(this).next().slideToggle(speed)
          //selects all other answers and slides up any open answer
          .siblings('li.checkout-a').slideUp();

        //Grab img from clicked question
        var img = $(this).children('img');
        //Remove Rotate class from all images except the active
        $('img').not(img).removeClass('rotate');
        //toggle rotate class
        img.toggleClass('rotate');
      }));
      
	  if ($('.cart__buttons-wrapper').length) {
    	addFAQMenu($, ".cart__buttons-wrapper");
        //gift card message 
        //addGiftCardMessage($, ".cart__buttons-wrapper");
  	  }
      
      //free item wth purchase
      addFreeItemWithPurchase();
      //holiday cart message
      if ($('.cart-container').length) {
        addHolidayMessage($, '.cart-container');
      }
      
      /*
      //move upsell to below the checkout form 
      let checkoutForm = 'form[action^="/cart"]:not([action^="/cart/add"])';
      //checkout page?
      if (location.pathname == '/cart' || location.pathname == '/cart/') {
        //check if upsell has been loaded 
        var upsellCount = 0;
        if (window.timerUpsell) clearInterval(window.timerUpsell);
        window.timerUpsell = setInterval(function() {
          upsellCount = upsellCount +1;
          if ($('.upsell-products-container').length) {
            clearInterval(window.timerUpsell);
            //get each address and check for delivery date
            $('.upsell-products-container').insertAfter(checkoutForm);
          }

          if (upsellCount > 1000) {
            clearInterval(window.timerUpsell);

          }
        }, 100);  
      }
      */

      cloneFreeShippingBar($);
      //clone multi shipping 
      
      //clone upsells 
      //cloneUpsells();

          
    $("#Cart").on("mouseup", "input#sc-discount__submit", (function (event) {
        //wait for coupon code to be submitted 
        if (window.timerCodeSearch) clearInterval(window.timerCodeSearch);
        window.timerCodeSearch = setInterval(function() {
            if ($(".sc_simple-info span.code").length) {
                // recalculate shipping banner
                calculateFSB();
                clearInterval(window.timerCodeSearch);
            }
        }, 100);
    
    }));
    $("#Cart").on("keydown", "input#code.sc-cube-text.sc-cube-code", (function (event) {
        if (event.keyCode == 13) {
            //wait for coupon code to be submitted 
            if (window.timerCodeSearch) clearInterval(window.timerCodeSearch);
            window.timerCodeSearch = setInterval(function() {
                if ($(".sc_simple-info span.code").length) {
                    // recalculate shipping banner
                    calculateFSB();
                    clearInterval(window.timerCodeSearch);
                }
            }, 100);
        }
    }));
    
    
    $("#Cart").on("mousedown", "button.button", (function(){
        //remove coupon
        if (window.timerCodeSearchRemove) clearInterval(window.timerCodeSearchRemove);
        window.timerCodeSearchRemove = setInterval(function() {
            if ($(".sc_simple-info span.code").length == 0) {
                // recalculate shipping banner
                calculateFSB();
                clearInterval(window.timerCodeSearchRemove);
            }
        }, 100);
    }));
  	});
  }

}

function checkDiscount($) {
  
  //wait for input button to be available 
  if (window.timerDCart) clearInterval(window.timerDCart);
  window.timerDCart = setInterval(function() {
      if ($('.code-name').length) {
          // found, so set check for udpate
        if ($(".code-name").length > 1) {
          //only one code?
          //console.log("multiple found: ", $(".code-name"));
          discCode = $(".code-name")[0].innerHTML;
        }
        else {
          discCode = $(".code-name").val();
        }
        //updateSlideCart($, discCode);

      }
    else {
      if ($(".code-name").length == 0 && ($(".sc-cube-code").length)) {
        //blank code, check for change 
        //updateSlideCart($, false);
      }
    }
  }, 500);
  //if the FSB bar is not enabled, clear the timer 
  if (typeof(deweysFSB) === 'undefined') {
    clearInterval(window.timerDCart);
  }
}

function updateSlideCart($, discCode) {
  if (typeof(deweysFSB) !== 'undefined') {
    if (discCode !== deweysFSB.discountCode) {
      //need to update code
      //console.log("code: ", discCode);
      deweysFSB.discountCode = discCode;
      if (discCode == '') {
        document.querySelector(".slidecarthq .footer-code button")?.click();
      }
      window.SLIDECART_APPLY_DISCOUNT(discCode);
      window.SLIDECART_UPDATE(function() {
        if (typeof(calculateFSB) !== 'undefined') {
          calculateFSB();
        }
        cloneFreeShippingBar($);
      });
    }
  }
}

function addFAQMenu($, addFAQSelector) {
  //create and append FAQ to checkout 
    if (!$('.checkout-faq-box').length) {
      //create toggle for mobile 
      var toggleInner = $("<span>").attr('class', 'order-summary-toggle__inner deweys-faq-toggle');
      var toggleIcon = $("<span>").attr('class', 'order-summary-toggle__icon-wrapper').attr('id', 'faqSVG');
      var iconSVG = $("<svg class='order-summary-toggle__icon' width='20' height='20' xmlns='http://www.w3.org/2000/svg'><path d='m2.872967,7.86834l0,-4.076646l2.723806,0l0,0.892133l-1.671574,0l0,0.700962l1.504579,0l0,0.890456l-1.504579,0l0,1.593095l-1.052232,0zm-0.170238,-7.618348l10.781733,0a2.707593,2.800493 0 0 1 2.702729,2.795463l0,5.817312a2.707593,2.800493 0 0 1 -2.702729,2.790432l-6.113972,0l-4.101923,3.65238a0.455589,0.471221 0 0 1 -0.749047,-0.387374l0.218877,-3.265006l-0.035669,0a2.707593,2.800493 0 0 1 -2.702729,-2.790432l0,-5.817312a2.707593,2.800493 0 0 1 2.702729,-2.795463zm15.078214,4.133662a2.662196,2.753539 0 0 1 2.149861,2.683107l0,6.238225a2.65409,2.745154 0 0 1 -2.647605,2.73677l-0.097279,0l0.217256,3.325376l0,0a0.398843,0.412528 0 0 1 -0.648525,0.335388l-4.126242,-3.768089l-6.425265,0l2.671924,-2.810555l6.660355,0a2.253625,2.33095 0 0 0 2.245519,-2.324242l0,-6.231517c0,-0.062047 0,-0.124094 0,-0.184464zm-4.289995,-3.18619l-10.788219,0a1.799658,1.861406 0 0 0 -1.783445,1.853021l0,5.812282a1.799658,1.861406 0 0 0 1.791551,1.844636l0.554489,0a0.453968,0.469544 0 0 1 0.421541,0.503083l-0.18483,2.651246l3.383681,-3.018496a0.452346,0.467867 0 0 1 0.324263,-0.135832l6.272861,0a1.799658,1.861406 0 0 0 1.783445,-1.844636l0,-5.817312a1.799658,1.861406 0 0 0 -1.783445,-1.844636l0.008107,-0.003354zm-6.971647,6.675907l-1.134919,0l1.263003,-4.081677l1.438105,0l1.277595,4.076646l-1.134919,0l-0.846326,-2.953095l-0.030805,0l-0.846326,2.953095l0.014592,0.005031zm-0.212392,-1.608188l2.12392,0l0,0.828409l-2.138512,0l0,-0.83344l0.014592,0.005031zm4.758555,0.095586l0.810657,0l0.28373,0.385697l0.499364,0.595314l0.648525,0.838471l-0.92577,0l-0.460453,-0.56513l-0.311292,-0.471221l-0.559353,-0.779778l0.014592,-0.003354zm2.255247,-0.524883a2.243898,2.320888 0 0 1 -0.252925,1.147028a1.679681,1.737312 0 0 1 -0.67933,0.705993a2.072038,2.143132 0 0 1 -1.908286,0a1.694272,1.752405 0 0 1 -0.677709,-0.709347a2.242276,2.319211 0 0 1 -0.249682,-1.141998a2.252004,2.329273 0 0 1 0.249682,-1.147028a1.689408,1.747374 0 0 1 0.677709,-0.70767a2.078524,2.14984 0 0 1 1.908286,0a1.694272,1.752405 0 0 1 0.67933,0.70767a2.23417,2.310826 0 0 1 0.252925,1.147028l0,-0.001677zm-1.083037,0a1.678059,1.735635 0 0 0 -0.092415,-0.617115a0.770124,0.796548 0 0 0 -0.269138,-0.38402a0.838219,0.866979 0 0 0 -0.880373,0a0.783094,0.809963 0 0 0 -0.270759,0.38402a1.716971,1.775882 0 0 0 -0.090794,0.617115a1.723456,1.78259 0 0 0 0.076202,0.618792a0.77823,0.804932 0 0 0 0.270759,0.382343a0.830112,0.858594 0 0 0 0.880373,0a0.76526,0.791517 0 0 0 0.269138,-0.382343a1.682923,1.740666 0 0 0 0.092415,-0.617115l0.014592,-0.001677z'></path></svg>");
      
      //iconSVG.attr('viewBox','').attr('viewBox', '0 0 122.88 116.6');
      
      //var iconPath = $("<path>").attr('d', 'm2.872967,7.86834l0,-4.076646l2.723806,0l0,0.892133l-1.671574,0l0,0.700962l1.504579,0l0,0.890456l-1.504579,0l0,1.593095l-1.052232,0zm-0.170238,-7.618348l10.781733,0a2.707593,2.800493 0 0 1 2.702729,2.795463l0,5.817312a2.707593,2.800493 0 0 1 -2.702729,2.790432l-6.113972,0l-4.101923,3.65238a0.455589,0.471221 0 0 1 -0.749047,-0.387374l0.218877,-3.265006l-0.035669,0a2.707593,2.800493 0 0 1 -2.702729,-2.790432l0,-5.817312a2.707593,2.800493 0 0 1 2.702729,-2.795463zm15.078214,4.133662a2.662196,2.753539 0 0 1 2.149861,2.683107l0,6.238225a2.65409,2.745154 0 0 1 -2.647605,2.73677l-0.097279,0l0.217256,3.325376l0,0a0.398843,0.412528 0 0 1 -0.648525,0.335388l-4.126242,-3.768089l-6.425265,0l2.671924,-2.810555l6.660355,0a2.253625,2.33095 0 0 0 2.245519,-2.324242l0,-6.231517c0,-0.062047 0,-0.124094 0,-0.184464zm-4.289995,-3.18619l-10.788219,0a1.799658,1.861406 0 0 0 -1.783445,1.853021l0,5.812282a1.799658,1.861406 0 0 0 1.791551,1.844636l0.554489,0a0.453968,0.469544 0 0 1 0.421541,0.503083l-0.18483,2.651246l3.383681,-3.018496a0.452346,0.467867 0 0 1 0.324263,-0.135832l6.272861,0a1.799658,1.861406 0 0 0 1.783445,-1.844636l0,-5.817312a1.799658,1.861406 0 0 0 -1.783445,-1.844636l0.008107,-0.003354zm-6.971647,6.675907l-1.134919,0l1.263003,-4.081677l1.438105,0l1.277595,4.076646l-1.134919,0l-0.846326,-2.953095l-0.030805,0l-0.846326,2.953095l0.014592,0.005031zm-0.212392,-1.608188l2.12392,0l0,0.828409l-2.138512,0l0,-0.83344l0.014592,0.005031zm4.758555,0.095586l0.810657,0l0.28373,0.385697l0.499364,0.595314l0.648525,0.838471l-0.92577,0l-0.460453,-0.56513l-0.311292,-0.471221l-0.559353,-0.779778l0.014592,-0.003354zm2.255247,-0.524883a2.243898,2.320888 0 0 1 -0.252925,1.147028a1.679681,1.737312 0 0 1 -0.67933,0.705993a2.072038,2.143132 0 0 1 -1.908286,0a1.694272,1.752405 0 0 1 -0.677709,-0.709347a2.242276,2.319211 0 0 1 -0.249682,-1.141998a2.252004,2.329273 0 0 1 0.249682,-1.147028a1.689408,1.747374 0 0 1 0.677709,-0.70767a2.078524,2.14984 0 0 1 1.908286,0a1.694272,1.752405 0 0 1 0.67933,0.70767a2.23417,2.310826 0 0 1 0.252925,1.147028l0,-0.001677zm-1.083037,0a1.678059,1.735635 0 0 0 -0.092415,-0.617115a0.770124,0.796548 0 0 0 -0.269138,-0.38402a0.838219,0.866979 0 0 0 -0.880373,0a0.783094,0.809963 0 0 0 -0.270759,0.38402a1.716971,1.775882 0 0 0 -0.090794,0.617115a1.723456,1.78259 0 0 0 0.076202,0.618792a0.77823,0.804932 0 0 0 0.270759,0.382343a0.830112,0.858594 0 0 0 0.880373,0a0.76526,0.791517 0 0 0 0.269138,-0.382343a1.682923,1.740666 0 0 0 0.092415,-0.617115l0.014592,-0.001677z');
      
      //iconSVG.append(iconPath);
      toggleIcon.append(iconSVG);
      //toggleInner.append(toggleIcon);

          
      var toggle = $("<span>").attr('class', 'order-summary-toggle__text order-summary-toggle__text--show');
      toggle.append(toggleIcon);
      toggle.append($("<span>").text("Show Frequently Asked Questions"));
      //toggle.append($("<svg>").attr('width', '11').attr('height', '6').attr('xmlns', 'http://www.w3.org/2000/svg').attr('class', 'order-summary-toggle__dropdown').attr('fill', '#000').append($("<path>").attr('d', 'M.504 1.813l4.358 3.845.496.438.496-.438 4.642-4.096L9.504.438 4.862 4.534h.992L1.496.69.504 1.812z')));
      var toggleSVG = $(".order-summary-toggle__dropdown").clone(true);
      if (toggleSVG.length > 1) {
        toggleSVG = toggleSVG[0];
      }
      toggle.append(toggleSVG);
      toggleInner.append(toggle);
      $("span.order-summary-toggle__inner").after(toggleInner);
      
      
      //create FAQ
      // TO DO: create a theme option or a configuration file to edit the FAQ questions and answers
      var faqBox = $("<div>").attr('class', 'checkout-faq-box');
      var faqTitleDiv = $("<div>").attr('class', 'checkout-faq-title');
      var faqTitle = $("<h3>").text("Frequently Asked Questions");
      faqTitleDiv.append(faqTitle);
      faqBox.append(faqTitleDiv);

      var faqList = $("<ul>").attr('class', 'checkout-faq');


      var faqFound = false;
      if (typeof faqEntries !== 'undefined' && faqEntries.length > 0) {
        faqEntries.forEach(function (item, index) {
          if (item.question) {
            faqFound = true;
            //Create FAQ item
            var faqListItemQ = $("<li>").attr('class', 'checkout-q').text(item.question);
            var faqArrow = $("<img>").attr('src', "https://cdn.shopify.com/s/files/1/0534/3192/6942/files/arrow.png?v=1624911295").attr('style', 'margin-left:10px;').attr("alt", "Toggle FAQ");
            faqListItemQ.append(faqArrow);
            var faqListItemA = $("<li>").attr('class', 'checkout-a').html(item.answer);
            //append FAQ item to list
            faqList.append(faqListItemQ);
            faqList.append(faqListItemA);
          }
        });
      }
      if (faqFound) {
        //append faq list to box
        faqBox.append(faqList);
        //append FAQ box to order summary
        $(addFAQSelector).append(faqBox);
      }

      //append faq list to box
      faqBox.append(faqList);
      //append FAQ box to order summary
      $(addFAQSelector).append(faqBox);
    }
}

function addGiftCardMessage($, addMessageSelector) {
  //create and append gift card message to checkout 
    if (!$('.checkout-gift-card-message').length) {
      var msgBox = $("<div>").attr('class', 'checkout-gift-card-message');
      var msgTitle = $("<strong>").text("Have a gift card? Enter that in the box on the next page while checking out.");
      msgBox.append(msgTitle);
      //prepend message box to order summary
      $(addMessageSelector).prepend(msgBox);
    }
}

function addFreeItemWithPurchase() {
  //check date - calling function from deweys-checkout.js  
  //free variant id set in theme.liquid & cart.liquid
    dt = getFormattedDate();
    if (dt >= '2022-04-06' && dt < '2022-04-14') {
      
      for (var i=0; i<cartItems.length; i++) {
        if ( cartItems[i].id == freeVariantId ) {
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }
      if ( ( cartItems.length === 1 ) && ( qtyInTheCart == 1 ) ) {
        cartUpdates = "updates["+freeVariantId+"]=2";//{ freeVariantId : 0 }
      }
      else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart == 0 ) ) {
        cartUpdates = "updates["+freeVariantId+"]=1";//{ freeVariantId : 1 }
      }
      else {
        return;
      }
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: cartUpdates,
        dataType: 'json',
        success: function(stuff) { 
          window.location.href = '/cart';
        }
      };
      $.ajax(params);
    }
}
function addHolidayMessage ($, addMessageSelector) {
  //get date
  dt = getFormattedDate();
  if (dt < '2023-01-03') {
    $(addMessageSelector).prepend("<div style='background-color: #f0b537;text-align:center;border: 1px solid #e2e2e2;padding:10px;margin-bottom:5px;'><h4 style='color:#fff!important;text-align:center!important;margin-bottom:0;'>Due to increased demand, orders placed after 12/29/22 will not ship until 1/3/22.</h4></div>");
  }
  else if (dt < '2021-12-24'){
    $(addMessageSelector).prepend("<div style='background-color: #f0b537;text-align:center;border: 1px solid #e2e2e2;padding:10px;'><h3 style='color:#fff!important;'>Allow some time for carrier delays during this busy season! We recommend 2-day or overnight shipping for orders placed today to be delivered by Christmas.</h3></div>");
  }
}

function getFormattedDate() {
    //var d = new Date(),
    var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"})),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

function getDeliveryDates(jQ, zipCode, authKey, timeCode, holidays="") {
  var holidayArray = holidays.split(/[,\s]+/);
  var postVals =  {
    'holidays' : holidayArray
  };

  jQ.ajax({
    url: 'https://ochatbot.ometrics.com/shopifyometrics/deweysServiceLookup/'+authKey+'/'+String(timeCode)+'/'+zipCode,
    type: 'GET',
    dataType: 'json',
    data: jQ.param(postVals)
  }).done(function(data) {
    // If successful
    //console.log(data);
    if (data.services) {
      jQ("span.radio__label__primary").each(function() {
          var deliveryEstimate = jQ("<span>").attr('class', 'small-text');
          var deliveryText = '';
          if (jQ(this).data('shipping-method-label-title') == 'Economy' || jQ(this).data('shipping-method-label-title') == 'Standard') {
            //find economy delivery estimate
            if (typeof(data.services['FEDEX_GROUND']) !== 'undefined') {
              deliveryText = "Estimated Delivery is " + data.services['FEDEX_GROUND'];
              var deliverySpan = jQ(this).find('span');
              if (typeof(deliverySpan) === 'undefined' || deliverySpan.length == 0) {
                jQ(this).append(deliveryEstimate.html('<br>'+deliveryText));
              }
              else {
                deliverySpan.text(deliveryText);
              }
            }
            else if (typeof(data.services['GROUND_HOME_DELIVERY']) !== 'undefined') {
              deliveryText = "Estimated Delivery is " + data.services['GROUND_HOME_DELIVERY'];
              var deliverySpan = jQ(this).find('span');
              if (typeof(deliverySpan) === 'undefined' || deliverySpan.length == 0) {
                jQ(this).append(deliveryEstimate.html('<br>'+deliveryText));
              }
              else {
                deliverySpan.text(deliveryText);
              }
            }
          }
          else if (jQ(this).data('shipping-method-label-title') == 'FedEx 2Day®') {
            //find economy delivery estimate
            if (typeof(data.services['FEDEX_2_DAY']) !== 'undefined') {
              deliveryText = "Estimated Delivery is " + data.services['FEDEX_2_DAY'];
              var deliverySpan = jQ(this).find('span');
              if (typeof(deliverySpan) === 'undefined' || deliverySpan.length == 0) {
                jQ(this).append(deliveryEstimate.html('<br>'+deliveryText));
              }
              else {
                deliverySpan.text(deliveryText);
              }
            }
          }
          else if (jQ(this).data('shipping-method-label-title') == 'FedEx Standard Overnight®') {
            //find economy delivery estimate
            if (typeof(data.services['STANDARD_OVERNIGHT']) !== 'undefined') {
              deliveryText = "Estimated Delivery is "+data.services['STANDARD_OVERNIGHT'];
              var deliverySpan = jQ(this).find('span');
              if (typeof(deliverySpan) === 'undefined' || deliverySpan.length == 0) {
                jQ(this).append(deliveryEstimate.html('<br>'+deliveryText));
              }
              else {
                deliverySpan.text(deliveryText);
              }
            }
          }
      });
    }
  }).fail(function(jqXHR, textStatus, errorThrown) {
    // If fail
    console.log(textStatus + ': ' + errorThrown);

  });
}

function cloneFreeShippingBar($) {
  //clone the free shipping bar and place above the checkout form  
  //console.log("in cloneFreeShippingBar");
  if (window.timerCloneBar) clearInterval(window.timerCloneBar);
  var cloneBarCount = 0;
  window.timerCloneBar = setInterval(function() {
    cloneBarCount++;
    if (cloneBarCount < 75) {
      if (cloneBarCount > 20) {
        if ($ == null && deweysJquery != null) {
            $ = deweysJquery;
        }
        if ($ != null) {
            if ($("#deweys_fsb_bar").length) {    
                //remove existing cloned bar 
                $("#deweys_fsb_bar_clone").remove();
                var cloneBar = $("#deweys_fsb_bar").clone();
                cloneBar.attr("id","deweys_fsb_bar_clone");
                if (cloneBar) {
                  $(".cart-form").prepend(cloneBar);
                  //css 
                  $(".checkout-buttons").css({'padding-top': '38px'})
                  $(".cart-table").css({'padding-top': '38px'})
                }
                //console.log("cloneFreeShippingBar done");
                clearInterval(window.timerCloneBar);
            }
        }
      }
    }
    else {
      clearInterval(window.timerCloneBar);
    }
  }, 100);
}

function cloneUpsells() {

  
      if (window.timerCloneUpsells) clearInterval(window.timerCloneUpsells);
      var cloneUpsellsCount = 0;
      window.timerCloneUpsells = setInterval(function() {
        cloneUpsellsCount++;
        if (cloneUpsellsCount < 50) {
          if ($("#slidecarthq .upsells").length) {
              var cloneUpsells =  $("#slidecarthq .upsells").clone();
              cloneUpsells.attr("id", "cartUpsells");

              if (cloneUpsells) {
                //$("#CartItems").append($('<div id="slidecarthq" class=""><div class="cloneUpsells"></div></div>'));
                //$(".cloneUpsells").append(cloneUpsells);
                cloneUpsells.appendTo("#CartItems");
              }
              clearInterval(window.timerCloneUpsells);
          }  
        }
        else {
          clearInterval(window.timerCloneUpsells);
        }
      }, 100);
      
      
      $(document).on('click','#cartUpsells .upsell-add button',function(event){
        event.preventDefault();
        var pid = $(this).parents('.upsell').data("slidecart-product-id"); 
        var vid = 0;
        //get variant id from upsells
        if (typeof(window.SLIDECART_STATE().aupsells) !== 'undefined') {
          for (let i = 0; i < window.SLIDECART_STATE().aupsells.length; i++) {
            if (typeof(window.SLIDECART_STATE().aupsells[i].product) !== 'undefined') {
              if (window.SLIDECART_STATE().aupsells[i].product.id == pid) {
                vid = typeof(window.SLIDECART_STATE().aupsells[i].product.variants[0].id) !== 'undefined'? window.SLIDECART_STATE().aupsells[i].product.variants[0].id : 0;
                i = window.SLIDECART_STATE().aupsells.length;
              }
            }
          }
          if (vid !== 0) {
            $.ajax({
              type: 'POST',
              url: window.Shopify.routes.root + 'cart/add.js',
              data: {
                quantity: 1,
                id: vid
              },
              dataType: 'json', 
             success: function (data) { 
              location.reload();
              //console.log("success: ", data)
             } 
           });
          }
        } 
        
      })
      
}


